module.exports = __webpack_public_path__ + "img/JohnD.4aea5056.png";